import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhTW from './zh-TW/common';
import en from './en/common';

const storedLocale = typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function'
  ? localStorage.getItem('invoice-locale')
  : null;

void i18n.use(initReactI18next).init({
  resources: { 'zh-TW': { translation: zhTW }, en: { translation: en } },
  lng: storedLocale ?? import.meta.env.VITE_DEFAULT_LOCALE ?? 'zh-TW',
  fallbackLng: 'zh-TW',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
